import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { FETCH_POST } from '../../config';
import PageTitle from '../../components/shared/PageTitle';

/**
 * PayTR Ödeme Bekle Sayfası
 *
 * PayTR'a ödeme isteği gönderildikten sonra,
 * callback'ten sonuç gelene kadar payment session durumunu kontrol eder.
 * Her saniyede bir status kontrol edilir.
 */
class PaymentWaiting extends Component {
  state = {
    checkCount: 0,
    maxChecks: 60, // 60 saniye timeout
    status: 'pending',
    message: 'Ödemeniz işleniyor, lütfen bekleyiniz...'
  };

  componentDidMount() {
    window.scrollTo(0, 0);

    // State kontrolü
    if (!this.props.location.state || !this.props.location.state.merchant_oid) {
      this.props.dispatch(push('/'));
      return;
    }

    // Her saniyede bir payment session durumunu kontrol et
    this.interval = setInterval(this.checkPaymentStatus, 1000);
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  checkPaymentStatus = async () => {
    var merchant_oid = this.props.location.state.merchant_oid;
    var checkCount = this.state.checkCount;

    if (checkCount >= this.state.maxChecks) {
      // Timeout
      clearInterval(this.interval);
      this.setState({
        status: 'timeout',
        message: 'Ödeme zaman aşımına uğradı'
      });

      // Checkout sayfasına geri dön
      setTimeout(function () {
        this.props.dispatch(push('/odeme'));
      }.bind(this), 3000);

      return;
    }

    try {
      // GraphQL ile payment session durumunu kontrol et
      var query = 'query { checkPaymentStatus(merchant_oid: "' + merchant_oid + '") { status order_id error_message } }';
      var result = await FETCH_POST({ query: query, variables: {} });

      if (result.data.data && result.data.data.checkPaymentStatus) {
        var paymentStatus = result.data.data.checkPaymentStatus.status;

        if (paymentStatus === 'success') {
          // Ödeme başarılı
          clearInterval(this.interval);
          this.setState({
            status: 'success',
            message: 'Ödeme başarılı! Yönlendiriliyorsunuz...'
          });

          // Success sayfasına yönlendir
          setTimeout(function () {
            this.props.dispatch(push({
              pathname: '/siparis-basarili',
              state: {
                is_guest: this.props.location.state.is_guest,
                order: { id: result.data.data.checkPaymentStatus.order_id }
              }
            }));
          }.bind(this), 1500);

          return;

        } else if (paymentStatus === 'failed') {
          // Ödeme başarısız
          clearInterval(this.interval);
          this.setState({
            status: 'failed',
            message: 'Ödeme başarısız: ' + (result.data.data.checkPaymentStatus.error_message || 'Bilinmeyen hata')
          });

          // Checkout sayfasına geri dön
          setTimeout(function () {
            this.props.dispatch(push('/odeme'));
          }.bind(this), 3000);

          return;
        }
      }

      this.setState({ checkCount: checkCount + 1 });

    } catch (error) {
      console.error('Payment status check error:', error);
      this.setState({ checkCount: checkCount + 1 });
    }
  };

  render() {
    var status = this.state.status;
    var message = this.state.message;

    var iconClass = 'fa fa-spinner fa-spin';
    var iconColor = '#007bff';

    if (status === 'success') {
      iconClass = 'fa fa-check-circle';
      iconColor = '#28a745';
    } else if (status === 'failed' || status === 'timeout') {
      iconClass = 'fa fa-times-circle';
      iconColor = '#dc3545';
    }

    return (
      <React.Fragment>
        <PageTitle title="Ödeme İşleniyor" />
        <div className="container" style={{ paddingTop: '50px', paddingBottom: '100px' }}>
          <div className="row justify-content-center">
            <div className="col-md-6 text-center">
              <div
                style={{
                  background: '#fff',
                  padding: '40px',
                  borderRadius: '10px',
                  boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
                }}
              >
                <i
                  className={iconClass}
                  style={{
                    fontSize: '80px',
                    color: iconColor,
                    marginBottom: '20px'
                  }}
                ></i>

                <h3 style={{ marginBottom: '15px' }}>
                  {status === 'success' && 'Ödeme Başarılı!'}
                  {status === 'failed' && 'Ödeme Başarısız'}
                  {status === 'timeout' && 'Zaman Aşımı'}
                  {status === 'pending' && 'Ödemeniz İşleniyor...'}
                </h3>

                <p className="text-muted">{message}</p>

                {status === 'pending' && (
                  <div className="mt-4">
                    <div className="progress" style={{ height: '5px' }}>
                      <div
                        className="progress-bar progress-bar-striped progress-bar-animated"
                        role="progressbar"
                        style={{ width: (this.state.checkCount / this.state.maxChecks) * 100 + '%' }}
                      ></div>
                    </div>
                    <small className="text-muted mt-2 d-block">
                      Lütfen sayfayı kapatmayın...
                    </small>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

var mapStateToProps = function (state) {
  return {};
};

export default connect(mapStateToProps)(PaymentWaiting);



// WEBPACK FOOTER //
// ./src/routers/Checkout/waiting.js